var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-screen flex w-full bg-img" }, [
    _c(
      "div",
      {
        staticClass:
          "vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
      },
      [
        _c("vx-card", [
          _c(
            "div",
            {
              staticClass: "full-page-bg-color",
              attrs: { slot: "no-body" },
              slot: "no-body"
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
                  },
                  [
                    _c("img", {
                      staticClass: "mx-auto",
                      attrs: {
                        src: require("@/assets/images/pages/reset-password.png"),
                        alt: "login"
                      }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "vx-logo flex justify-items-center items-center mb-2 pt-4"
                      },
                      [
                        _c("img", {
                          staticClass: "mx-auto",
                          staticStyle: { "max-height": "25px" },
                          attrs: {
                            src: require("@/assets/images/logo/logo.png"),
                            alt: "logo"
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "vx-card__title mb-8 grid justify-items-center"
                          },
                          [
                            _c("h4", { staticClass: "mb-4" }, [
                              _vm._v("Primeiro Acesso")
                            ]),
                            _c("p", [
                              _vm._v("Por favor altere sua senha temporária")
                            ])
                          ]
                        ),
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|verify_password",
                              expression: "'required|verify_password'"
                            }
                          ],
                          ref: "password",
                          staticClass: "w-full pb-2 pt-2",
                          attrs: {
                            type: "password",
                            id: "password",
                            name: "password",
                            "label-placeholder": "Senha",
                            "data-vv-as": "Senha"
                          },
                          model: {
                            value: _vm.password,
                            callback: function($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("password")))
                        ]),
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|confirmed:password",
                              expression: "'required|confirmed:password'"
                            }
                          ],
                          staticClass: "w-full pb-2 pt-2",
                          attrs: {
                            type: "password",
                            name: "password_confirmation",
                            id: "password_confirmation",
                            "data-vv-as": "Confirmação Senha",
                            "label-placeholder": "Confirmar senha"
                          },
                          model: {
                            value: _vm.passwordConfirm,
                            callback: function($$v) {
                              _vm.passwordConfirm = $$v
                            },
                            expression: "passwordConfirm"
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(
                            _vm._s(_vm.errors.first("password_confirmation"))
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-wrap justify-center sm:flex-row mt-8"
                          },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass:
                                  "w-full sm:w-auto mb-4 mt-4 mr-4 ml-4 sm:mb-auto sm:mt-auto",
                                attrs: { disabled: !_vm.validateForm },
                                on: { click: _vm.changePassword }
                              },
                              [_vm._v("Alterar")]
                            ),
                            _c(
                              "vs-button",
                              {
                                staticClass:
                                  "w-full sm:w-auto mb-4 mt-4 mr-4 ml-4 sm:mb-auto sm:mt-auto",
                                attrs: { type: "border" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v("Voltar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }